import React, { PropsWithChildren, createContext, useState } from "react";
import { createFPPSearchFilterSelectors } from "../redux/selectors";
import { WorkspaceState } from "../redux/reducer";
import { SearchFilterState as WebUiSearchFilterState } from "@stenajs-webui/filter";
import { useSelector } from "react-redux";

export interface SearchFilterSelectorContextType {
  workspaceState: WebUiSearchFilterState<WorkspaceState>;
  committedState: WorkspaceState;
}

const SearchFilterSelectorContext =
  createContext<SearchFilterSelectorContextType | null>(null);

const SearchFilterSelectorProvider = ({
  children,
  reducerId,
}: PropsWithChildren<{ reducerId: string }>) => {
  const committedState = useSelector(
    createFPPSearchFilterSelectors(reducerId).getCommittedState
  );
  const workspaceState = useSelector(
    createFPPSearchFilterSelectors(reducerId).getWorkspaceState
  );

  return (
    <SearchFilterSelectorContext.Provider
      value={{ committedState, workspaceState }}
    >
      {children}
    </SearchFilterSelectorContext.Provider>
  );
};

export { SearchFilterSelectorProvider, SearchFilterSelectorContext };
